import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import "swiper/css";
import "swiper/css/pagination";
import { Messages } from "core/constants";
import { SelfServiceContext } from "core/context/self-service.context";
import { Bouquet } from "core/stores/subscriptions.store";
import { SquareLoader } from "components/common-ui";

const testData: Array<Bouquet> = [
    {
        name: "Work",
        tvPoints: 9,
        packages: []
    },
    {
        name: "Play",
        tvPoints: 4,
        packages: []
    },
    {
        name: "Stay",
        tvPoints: 19,
        packages: []
    }
];

const Subscriptions = observer(() => {
    const selfServiceContext = useContext(SelfServiceContext);
    const useTestData = false;

    const store = selfServiceContext.stores.subscriptions;

    const bouquets = useTestData ? testData : store.bouquets;

    const content = {
        stay: "Stay packages elevate your hospitality for all families, businesses, sports, kids & more!",
        play: "Keep your business packed to the rafters by giving your patrons a world of entertainment worth cheering for",
        work: "Engage your staff with news, commerce, and sports entertainment that makes for unforgettable watercooler moments"
    };

    const retry = async () => {
        await selfServiceContext.managers.subscriptions.populateAsync();

    }
    const packageTile = (bouquet: Bouquet, useSlide: boolean) => {
        if (!(bouquet?.name)) {
            return null;
        }

        const contentKey = bouquet.name.toLowerCase() as keyof typeof content;
        const desc = content[contentKey];

        return (
            <div key={bouquet.name} className={`package-${bouquet.name.toLowerCase()}`}>
                <h2>{`${bouquet.tvPoints.toLocaleString()} ${bouquet.name} TVs`}</h2>

                <p>
                    {desc}
                </p>
            </div>
        )
    }

    if (!useTestData && store.isLoading) {
        return (
            <div className="subscriptions-loader">
                <SquareLoader />
            </div>);
    }

    if (store.hasError) {
        return <>
            <p>
                {Messages.apiError}
            </p>
            <p>
                <span onClick={retry} className="anchor">Retry</span>
            </p>
        </>
    }

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>
        {bouquets?.map(x => packageTile(x, false))}
    </>;
});

export default Subscriptions;
